import { useEffect } from "react";
import { useConfig } from "@/lib/config";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Applies admin-controlled, DB-backed SEO to <head> at runtime (from /api/config):
 * document title, meta description, OpenGraph/Twitter tags, and catalog-driven JSON-LD.
 * This makes SEO editable from the Admin console with no redeploy and no hardcoded prices.
 */
export default function SeoHead() {
  const { config } = useConfig();

  useEffect(() => {
    const seo = config?.seo;
    if (seo) {
      if (seo.title) document.title = seo.title;
      upsertMeta("name", "description", seo.description);
      upsertMeta("property", "og:title", seo.og_title);
      upsertMeta("property", "og:description", seo.og_description);
      upsertMeta("property", "og:image", seo.og_image);
      upsertMeta("property", "og:url", seo.og_url);
      upsertMeta("name", "twitter:card", seo.twitter_card);
      upsertMeta("name", "twitter:title", seo.twitter_title);
      upsertMeta("name", "twitter:description", seo.twitter_description);
    }

    const jsonld = config?.seo_jsonld;
    if (Array.isArray(jsonld) && jsonld.length) {
      document.querySelectorAll("script[data-dynamic-jsonld]").forEach((n) => n.remove());
      jsonld.forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-dynamic-jsonld", "1");
        s.text = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
  }, [config]);

  return null;
}
